import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/usuarios`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(rol) {
    return apiClient.post(`roles/${rol.id}`, rol)
  },

  copiar(idRol, nuevoNombreRol) {
    return apiClient.post(`roles/${idRol}/copiar`, { nombre: nuevoNombreRol })
  },

  eliminar(idRol) {
    return apiClient.delete(`roles/${idRol}`)
  },

  guardar(rol) {
    return apiClient.post('roles', rol)
  },

  rolJSON(id) {
    return apiClient.get(`roles/${id}.json`)
  },

  rolesJSON(params) {
    params = params || {}
    return apiClient.get('roles.json', {params: params})
  }
}
